import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { toggleSwitch, popUpMessageChange } from '../../actions/index';
import { ToggleActions } from '../../constants/constants.js';
import GanttView from './gantt.js';
import Button from '@material-ui/core/Button'
import { nextYear } from '../../functions/utils.js';

const GanttChartDates = (props) => {
  const [tasks, setTasks] = useState({data:[],links:[]});
  const handleClose = () => {
    if(!props.popUpMessage.show) {
      props.toggleSwitch(ToggleActions.GANTT_CHART_DATES);
      props.popUpMessageChange({show: false})
    }
  };
    useEffect(() => {
      if (props.selectedCardsGroups !== 'none') {
        let data = []
        let links = []
        const grouped = {};
        props.selectedCardsGroups.forEach((cardsGroupId) => {
          let cardsGroupData = props.projectData.cards_groups[cardsGroupId]
          if (cardsGroupData) {
            let levelId = cardsGroupData.attributes.level_id;
            let categoryId = cardsGroupData.attributes.card_category_id;
  
            if (!grouped[levelId]) {
              grouped[levelId] = {};
            }

            if (!categoryId) {
              categoryId = 'Sin categoría'
            }
  
            if (!grouped[levelId][categoryId]) {
              grouped[levelId][categoryId] = [];
            }
            
            grouped[levelId][categoryId].push(cardsGroupData);
          }
        })
        Object.keys(grouped).forEach(levelId => {
          const levelName = props.projectData.levels[levelId].attributes.name;
          let task = {
            id: levelId,
            text: levelName,
            open: true,
            color:'rgb(32, 49, 99)'
          }
          data.push(task)
          
          Object.entries(grouped[levelId]).forEach(([categoryId, cardsGroups]) => {
            const link = { "id": `${categoryId}${levelId}`, "source": levelId, "target": `${categoryId}${levelId}`, "type": "1" }
            links.push(link)
            let categoryName = ''
            if (categoryId === 'Sin categoría') {
              categoryName = categoryId
            } else {
              categoryName = props.projectData.card_categories[categoryId].attributes.name
            }
            let task = {
              id: `${categoryId}${levelId}`,
              text: categoryName,
              open: true,
              parent: levelId,
              color:'rgb(51, 76, 150)'
            }
            data.push(task)
            cardsGroups.forEach(cardsGroupData => {
              let startDate = cardsGroupData.attributes.start_date
              let endDate = cardsGroupData.attributes.finish_date
              if (startDate !== null ) {
                startDate = cardsGroupData.attributes.start_date.slice(0,10)
              }
              if (endDate !== null) {
                endDate = cardsGroupData.attributes.finish_date.slice(0,10) 
              }

              let protocolId = cardsGroupData.attributes.protocol_id
              let protocolName = ''
              let protocolGroupName = ''
              if (protocolId) {
                  protocolId = protocolId.toString()
                  Object.values(props.projectData.protocolgroups).forEach(protocolGroup => {
                      if (Object.keys(protocolGroup.protocols).includes(protocolId)) {
                          protocolGroupName = protocolGroup.attributes.name
                          protocolName = protocolGroup.protocols[protocolId].attributes.name
                      }
                  })
              }
              let protocolTotalName = protocolGroupName + ' - ' + protocolName
              let description = protocolTotalName;
              
              if (cardsGroupData.attributes.first_card_description) {
                  description = cardsGroupData.attributes.first_card_description;
              }
              if (!protocolId) {
                  if (description === ' - ') {
                      let customCardName = props.projectData.customcards[cardsGroupData.attributes.customcard_id].attributes.name
                      if (customCardName) {
                          description = customCardName
                      }
                      let customCardFields = props.projectData.customcards[cardsGroupData.attributes.customcard_id].customcardfields
                      let notEmptyCustomCardFields = Object.values(customCardFields).filter(c => {if(c != {}) return c})
                      if(notEmptyCustomCardFields.length > 0) {
                          let fistNotEmptyCustomCardField = notEmptyCustomCardFields[0]
                          if (fistNotEmptyCustomCardField) {
                              let referenceField = fistNotEmptyCustomCardField.attributes.reference_field
                              let referenceFieldValue = props.projectData.cards_groups[cardsGroupData.id].attributes[referenceField]
                              if (referenceFieldValue) {
                                  description = description + ' - ' + referenceFieldValue
                              }
                          }
                      }
                  }
              }
              description = cardsGroupData.attributes.index + ' - ' + description
              let color = ''
              let noDateColor = 'rgba(204, 204, 204, 0.43)'
              if (!startDate || !endDate) {
                description = `<p style="margin: 0px;">${description}</p>
                                  <strong className="m-0">No tiene fechas asignadas</strong>
                                  <hr></hr>
                                  <strong className="m-0">(La fecha que aparece es por defecto <br></br> en el día de hoy)</strong>
                                `
                color = noDateColor
                if (props.projectData.days[props.projectData.days.length - 1]) {
                  endDate = props.projectData.days[props.projectData.days.length - 1].id
                }
                if (props.projectData.days[props.projectData.days.length - 2]) {
                  startDate = props.projectData.days[props.projectData.days.length - 2].id
                }
              }

              const link = { "id": cardsGroupData.id, "source": `${categoryId}${levelId}`, "target": cardsGroupData.id, "type": "1" }
              links.push(link)
              let task = {
                id: cardsGroupData.id,
                text: description,
                start_date: startDate,
                end_date: endDate,
                parent: `${categoryId}${levelId}`,
                open: true,
                color: color,
              }
              data.push(task)
            })

          });
        });
          
        let task = {
          id: 1,
          text: `<strong className="m-0">Rango de fechas</strong>`,
          start_date: props.projectData.days[0].id,
          end_date: nextYear(props.projectData.days[props.projectData.days.length - 1].id),
          open: true,
          color: 'white',
        }
        data.push(task)

        let tasks = {
          data: data,
          links: links
        }
        setTasks(tasks)
      }
    }, [props.selectedCardsGroups]);
    
    if (!props.ganttChartDates) return <div></div>

    return (
        <div className='m-3'>
          <div>
              <div className="close-button-gantt-dates" onClick={ handleClose }>
                <Button 
                    variant="contained" 
                    className='confirm-delete-button' 
                    style={{width: '20px', textTransform: 'none'}}>
                        <p style={{color:'white'}} className='m-0'>X</p>
                </Button>
              </div>
          </div>
          <GanttView tasks={tasks}></GanttView>
        </div>
    )
};

function mapStateToProps( state ){
    return {
        ganttChartDates : state.switches.ganttChartDates,
        projectData : state.projectData,
        selectedCardsGroups : state.selectedCardsGroups,
        popUpMessage : state.popUpMessage
    }
}

const mapDispatchToProps = {
    toggleSwitch: toggleSwitch,
    popUpMessageChange: popUpMessageChange,
};

export default connect(mapStateToProps, mapDispatchToProps)(GanttChartDates);